<div class="klarna-wrap">
  <div class="klarna-logo"></div>
  <div data-snippet class="data-snippet">
  </div>
</div>
